import type {
  EmailTemplate,
  EmailTemplateCreateInput,
  EmailTemplateUpdateInput,
} from '@beacon/core';

import type { BeaconClient } from '../client.js';

export interface EmailTemplateListResponse {
  templates: EmailTemplate[];
}

export const emailTemplatesApi = {
  list(client: BeaconClient): Promise<EmailTemplateListResponse> {
    return client.get<EmailTemplateListResponse>('/api/email-templates');
  },

  create(
    client: BeaconClient,
    input: EmailTemplateCreateInput
  ): Promise<EmailTemplate> {
    return client.post<EmailTemplate>('/api/email-templates', input);
  },

  update(
    client: BeaconClient,
    id: string,
    input: EmailTemplateUpdateInput
  ): Promise<EmailTemplate> {
    return client.patch<EmailTemplate>(
      `/api/email-templates/${encodeURIComponent(id)}`,
      input
    );
  },

  remove(client: BeaconClient, id: string): Promise<void> {
    return client.delete<void>(
      `/api/email-templates/${encodeURIComponent(id)}`
    );
  },
};
